//
//
//
//
//
//
//
//

export default {
  name: 'LabelTag',
  props: {
    label: {
      type: String,
      default: () => ''
    }
  }
}
